import { AnalyticsService } from "./analytics.service";
import { HttpService } from "./http.service";
import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import * as $ from 'jquery';

export class FormsService {

	private static instance: FormsService;

	constructor() {
	}

	static getInstance() {
		if (!FormsService.instance) {
			FormsService.instance = new FormsService();
		}
		return FormsService.instance;
	}

	postForm(url, fields, config) {
		let results: any = axios.post(url, fields, config).then(function (response) {
			// service ok
			return response;
		}).catch(function (response) {
			// service failed
			return response;
		});
		return results;
	}

	serializeForm(form) {
		/*!
		* Serialize all form data into a query string
		* (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
		* @param  {Node}   form The form to serialize
		* @return {String}      The serialized form data
		*/

		// Setup our serialized data
		var serialized = [];

		// Loop through each field in the form
		for (var i = 0; i < form.elements.length; i++) {

			var field = form.elements[i];

			// Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
			if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

			// If a multi-select, get all selections
			if (field.type === 'select-multiple') {
				for (var n = 0; n < field.options.length; n++) {
					if (!field.options[n].selected) continue;
					serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
				}
			}

			// Convert field data to a query string
			else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
				serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
			}
		}

		return serialized.join('&');
	}
	
	detect(form: HTMLFormElement, loader: Element, thankyou: Element) {
		switch (form.id) {

			case 'apply-now-submit_application':
				this.SubmitApplicationForm(form, loader, thankyou);
				break;

			case 'apply-now-submit_application_business':
				this.SubmitApplicationFormBusiness(form, loader, thankyou);
				break;

			case 'call-me-back-submit_application_need_help':
				this.SubmitNeedHelpForm(form, loader, thankyou);
				break;

			case 'apply-now-submit_application_insurance':
				this.SubmitApplicationFormInsurance(form, loader, thankyou);
				break;

			case 'apply-now-submit_application_access_quote':
				this.SubmitApplicationFormAccessQuote(form, loader, thankyou);
				break;

			case 'apply-now-submit_application_access_quote_pc':
				this.SubmitApplicationFormAccessQuotePc(form, loader, thankyou);
				break;

			case 'apply-now-submit_application_mail':
				this.SubmitApplicationFormMail(form, loader, thankyou);
				break;

			default:
				break;

		}
	}

	SubmitApplicationForm(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// fields
		const description: any = form.querySelector('input[name=description]');
		const firstname: any = form.querySelector('input[name=first-name]');
		const lastname: any = form.querySelector('input[name=last-name]');
		const contact: any = form.querySelector('input[name=phone-number]');
		const contact2: any = form.querySelector('input[name=phone-number-2]');
		const idnumber: any = form.querySelector('input[name=identification]');
		const email: any = form.querySelector('input[name=email]');
		const date: any = form.querySelector('input[name=date]');
		const time: any = form.querySelector('select[name=time]');
		const fullname: any = firstname.value + ' ' + lastname.value;

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitApplicationForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		let postData = '';

		if (description) {
			postData += 'description=' + description.value;
		}
		if (firstname && lastname) {
			postData += '&fullName=' + fullname;
		}
		if (contact) {
			postData += '&contact=' + contact.value;
		}
		if (contact2) {
			postData += '&contact2=' + contact2.value;
		}
		if (idnumber) {
			postData += '&idNum=' + idnumber.value;
		}
		if (email) {
			postData += '&email=' + email.value;
		}
		if (date) {
			if (time) {
				if (time.value !== "Anytime") {
					postData += '&timeToCall=' + date.value + ' ' + time.value;
				} else {
					postData += '&timeToCall=anytime';
				}
			} else {
				postData += '&timeToCall=anytime';
			}
		}
		postData += '&source=' + this.isMobile();

		// service
		axios.post(url, postData, config).then(function (response) {
			// service ok
			loader.classList.remove('active');
			if (response.data === 'invalid') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				loader.classList.remove('active');
				fieldsContainer.classList.remove('hidden');

			} else {
				analyticsService.dtmFormComplete('complete', response.data);
				loader.classList.remove('active');
				thankyou.classList.add('active');
			}

		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');

		});

	}

	SubmitApplicationFormBusiness(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// fields
		const enquiryType: any = form.querySelector('select[name=enquiry-type]');
		if (enquiryType && (enquiryType.value == "Enquiry")) {
			// fields

			const emailAddress: any = form.querySelector('input[name=email-address]');
			const recipient: any = form.querySelector('input[name=recipient]');
			const subject: any = form.querySelector('input[name=subject]');
			const description: any = form.querySelector('input[name=description]');
			const firstname: any = form.querySelector('input[name=first-name]');
			const lastname: any = form.querySelector('input[name=last-name]');
			const phoneNumber: any = form.querySelector('input[name=phone-number]');
			const altPhoneNumber: any = form.querySelector('input[name=alternative-number]');
			const email: any = form.querySelector('input[name=email]');

			// loader + hide form
			const fieldsContainer: any = form.querySelector('.form__fields--container');
			loader.classList.add('active');
			fieldsContainer.classList.add('hidden');

			// variables
			let analyticsService = new AnalyticsService();
			let url = "/services/SubmitGenericForm.jsp";
			const config = {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					"Access-Control-Allow-Origin": "*",
					'X-Requested-With': 'XMLHttpRequest'
				}
			}

			let postData = '';

			if (emailAddress) {
				postData += 'email=' + emailAddress.value;
			}
			if (recipient) {
				postData += '&recipient=' + recipient.value;
			}
			if (subject) {
				postData += '&subject=' + subject.value;
			}
			if (description) {
				postData += '&description=' + description.value;
			}
			if (firstname) {
				postData += '&firstname=' + firstname.value;
			}
			if (lastname) {
				postData += '&surname=' + lastname.value;
			}
			if (phoneNumber) {
				postData += '&contactNo=' + phoneNumber.value;
			}
			if (altPhoneNumber) {
				postData += '&AltContactNo=' + altPhoneNumber.value;
			}
			if (email) {
				postData += '&email-address=' + email.value;
			}
			const _documents = thankyou.querySelector('.form__thankyou--documents') as HTMLFormElement;
			if (_documents) {
				_documents.style.display = 'none';
			}
			// service
			axios.post(url, postData, config).then(function (response) {
				// service ok
				loader.classList.remove('active');
				analyticsService.dtmFormComplete('complete', '');
				loader.classList.remove('active');
				thankyou.classList.add('active');
			}).catch(function (response) {
				// service failed
				analyticsService.dtmFormComplete('complete', '');
				loader.classList.remove('active');
				thankyou.classList.add('active');
			});
		}
		else {
			const description: any = form.querySelector('input[name=description]');
			const firstname: any = form.querySelector('input[name=first-name]');
			const lastname: any = form.querySelector('input[name=last-name]');
			const businessType: any = form.querySelector('select[name=business-type]');
			const businessTypeValue: any = businessType.options[businessType.selectedIndex].value;
			const businessName: any = form.querySelector('input[name=business-name]');
			const phoneNumber: any = form.querySelector('input[name=phone-number]');
			const altPhoneNumber: any = form.querySelector('input[name=alternative-number]');
			const email: any = form.querySelector('input[name=email]');
			const businessRegNumber: any = form.querySelector('input[name=business-reg-number]');
			const idnumber: any = form.querySelector('input[name=id-number]');
			const existingCustomer: any = form.querySelector('input[name=existing-customer]');

			// loader + hide form
			const fieldsContainer: any = form.querySelector('.form__fields--container');
			loader.classList.add('active');
			fieldsContainer.classList.add('hidden')

			// variables
			let analyticsService = new AnalyticsService();

			let url = "/services/SubmitApplicationFormBizBankV1.jsp";
			const config = {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					"Access-Control-Allow-Origin": "*",
					'X-Requested-With': 'XMLHttpRequest'
				}
			}
			let postData = '';

			if (description) {
				postData += 'description=' + description.value;
			}
			if (firstname) {
				postData += '&firstname=' + firstname.value;
			}
			if (lastname) {
				postData += '&surname=' + lastname.value;
			}
			if (businessTypeValue) {
				postData += '&businessType=' + businessTypeValue;
			}
			if (businessName) {
				postData += '&businessName=' + businessName.value;
			}
			if (phoneNumber) {
				postData += '&contactNo=' + phoneNumber.value;
			}
			if (altPhoneNumber) {
				postData += '&AltContactNo=' + altPhoneNumber.value;
			}
			if (email) {
				postData += '&email=' + email.value;
			}
			if (businessRegNumber) {
				postData += '&businessRegNumber=' + businessRegNumber.value;
			}
			if (idnumber) {
				postData += '&idNumber=' + idnumber.value;
			}
			if (existingCustomer) {
				if (existingCustomer.checked) {
					postData += '&isExistingCustomer=YES';
				} else {
					postData += '&isExistingCustomer=NO';
				}
			}
			postData += '&source=' + this.isMobile();

			// service
			axios.post(url, postData, config).then(function (response) {
				// service ok
				loader.classList.remove('active');
				if (response.data === 'invalid') {
					analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
					loader.classList.remove('active');
					fieldsContainer.classList.remove('hidden');

				} else {
					analyticsService.dtmFormComplete('complete', response.data);
					loader.classList.remove('active');
					thankyou.classList.add('active');
					let _documents = thankyou.querySelector('.form__thankyou--documents') as HTMLFormElement;
					if (_documents) {
						_documents.removeAttribute('style');
						let _buttonContainer = _documents.querySelector('.form__thank--documents-button');

						const _subject = 'My Reference Number Is: ' + response.data;
						const _body = 'To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nID of owners and signatories\nProof of address not older than 3 months\nCompany registration documents if a registered company';

						let _mailtoText = 'mailto:SmallEnterpriseSales@standardbank.co.za&subject=' + encodeURIComponent(_subject) + '&body=' + encodeURIComponent(_body);
						let _newbutton = document.createElement('a');
						_newbutton.classList.add('button', 'button--large', 'button--centered', 'button--main');
						_newbutton.setAttribute('data-id', 'link_content_ documents email click');
						_newbutton.setAttribute('data-text', 'email documents button click');
						_newbutton.setAttribute('href', _mailtoText);


						const _text = document.createTextNode('EMAIL DOCUMENTS');
						_newbutton.appendChild(_text);
						_buttonContainer.innerHTML = '';
						_buttonContainer.appendChild(_newbutton);
					}
				}

			}).catch(function (response) {
				// service failed
				analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
				loader.classList.remove('active');
				fieldsContainer.classList.remove('hidden');

			});
		}
	}

	SubmitNeedHelpForm(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// fields
		const firstName: any = form.querySelector('input[name=first-name]');
		const lastName: any = form.querySelector('input[name=last-name]');
		const contactNumber: any = form.querySelector('input[name=phone-number]');
		const emailNeedHelp: any = form.querySelector('input[name=email]');
		const idNumber: any = form.querySelector('input[name=identification]');
		const senderEmail: any = form.querySelector('input[name=sender-email]');

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden')

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitNeedHelpForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		let postData = '';

		if (firstName) {
			postData += 'firstName=' + firstName.value;
		}
		if (lastName) {
			postData += '&lastName=' + lastName.value;
		}
		if (contactNumber) {
			postData += '&contactNumber=' + contactNumber.value;
		}
		if (emailNeedHelp) {
			postData += '&email=' + emailNeedHelp.value;
		}
		if (senderEmail) {
			postData += '&senderEmail=' + senderEmail.value;
		}
		if (idNumber) {
			postData += '&idNumber=' + idNumber.value;
		}

		postData += '&source=' + window.location.href;
		postData += '&sbUseragent=' + this.isMobile();

		// service
		axios.post(url, postData, config).then(function (response) {
			// service ok
			if (response.data === 'invalid') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				loader.classList.remove('active');
				fieldsContainer.classList.remove('hidden');

			} else {
				analyticsService.dtmFormComplete('complete', response.data);
				loader.classList.remove('active');
				thankyou.classList.add('active')
			}

		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');

		});

	}

	SubmitApplicationFormInsurance(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// fields
		const firstname: any = form.querySelector('input[name=first-name]');
		const lastname: any = form.querySelector('input[name=last-name]');
		const contact: any = form.querySelector('input[name=phone-number]');
		const productTypeSelect: any = form.querySelector('select[name=product-type]');
		const productTypeHidden: any = form.querySelector('input[name=product-type-hidden]');

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SBIS_Handler_COZA.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		let postData = '';

		if (firstname) {
			postData += 'first=' + firstname.value;
		}
		if (lastname) {
			postData += '&last=' + lastname.value;
		}
		if (contact) {
			postData += '&cell=' + contact.value;
		}
		if (productTypeSelect) {
			postData += '&product=' + productTypeSelect.value;
		} else {
			if (productTypeHidden) {
				postData += '&product=' + productTypeHidden.value;
			}
		}
		postData += '&source=' + this.isMobile();

		// service
		axios.post(url, postData, config).then(function (response) {
			// service ok
			loader.classList.remove('active');
			if (response.data === 'invalid') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				loader.classList.remove('active');
				fieldsContainer.classList.remove('hidden');

			} else {
				analyticsService.dtmFormComplete('complete', response.data);
				loader.classList.remove('active');
				thankyou.classList.add('active');
			}

		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');

		});

	}

	SubmitApplicationFormAccessQuote(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// additional containers
		let declined = form.querySelector('.form__declined--container');
		let success = form.querySelector('.form__success--container');
		let value = form.querySelector('.output-value');
		let name = form.querySelector('.form__success-container__firstname');

		// fields
		const description: any = form.querySelector('input[name=description]');
		const firstName: any = form.querySelector('input[name=first-name]');
		const lastName: any = form.querySelector('input[name=last-name]');
		const contact: any = form.querySelector('input[name=phone-number]');
		const contact2: any = form.querySelector('input[name=phone-number-2]');
		const gross: any = form.querySelector('input[name=gross]');
		const idNum: any = form.querySelector('input[name=identification]');
		const email: any = form.querySelector('input[name=email]');
		const date: any = form.querySelector('input[name=date]');
		const time: any = form.querySelector('select[name=time]');

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitApplicationFormAQ.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		let postData = '';

		if (description) {
			postData += 'description=' + description.value;
		}
		if (firstName) {
			postData += '&firstName=' + firstName.value;
		}
		if (lastName) {
			postData += '&lastName=' + lastName.value;
		}
		if (contact) {
			postData += '&contact=' + contact.value;
		}
		if (contact2) {
			postData += '&contact2=' + contact2.value;
		}
		if (gross) {
			postData += '&gross=' + gross.value;
		}
		if (idNum) {
			postData += '&idNum=' + idNum.value;
		}
		if (email) {
			postData += '&email=' + email.value;
		}
		if (date) {
			if (time) {
				if (time.value !== "Anytime") {
					postData += '&timeToCall=' + date.value + ' ' + time.value;
				} else {
					postData += '&timeToCall=anytime';
				}
			} else {
				postData += '&timeToCall=anytime';
			}
		}
		postData += '&source=' + this.isMobile();

		// service
		axios.post(url, postData, config).then(function (response: any) {

			let data = response.data;

			// service ok
			loader.classList.remove('active');

			if (data.validity) {

				if (data.aqResult == 'approve') {

					analyticsService.dtmFormComplete('complete', data.leadID);
					thankyou.classList.add('active');
					declined.classList.remove('active');
					success.classList.add('active');
					name.innerHTML = firstName.value;
					value.innerHTML = 'R' + data.amount;

				} else {

					analyticsService.dtmFormComplete('complete', 'DCE9999999999');
					analyticsService.dtmRecordSiteError('Access Quote Declined');
					thankyou.classList.add('active');
					success.classList.remove('active');
					declined.classList.add('active');

				}

			} else {

				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				thankyou.classList.add('active');
				success.classList.remove('active');
				declined.classList.add('active');

			}

		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');

		});

	}

	SubmitApplicationFormAccessQuotePc(form: HTMLFormElement, loader: Element, thankyou: Element) {

		let errors = [{
			"error": "Credit Decline 1",
			"message": "DD04_Score Decline",
			"code": "DD04"
		},
		{
			"error": "Decline 1",
			"message": "DA58_No Bureau Consent_PS",
			"code": "DA58"
		},
		{
			"error": "Decline 2",
			"message": "DA60_Under Admin Order_PS",
			"code": "DA60"
		},
		{
			"error": "Decline 3",
			"message": "DA61_Under Sequestration_PS",
			"code": "DA61"
		},
		{
			"error": "Decline 4",
			"message": "DA57_No Terms & Conditions_PS",
			"code": "DA57"
		},
		{
			"error": "Decline 5",
			"message": "DA53_Under Debt Review",
			"code": "DA53"
		},
		{
			"error": "Decline 6",
			"message": "DH67_Capture an RCP",
			"code": "DH67"
		},
		{
			"error": "Decline 7",
			"message": "DA59_Customer Has No Surplus",
			"code": "DA59"
		},
		{
			"error": "Decline 8",
			"message": "DD02_Adverse Status",
			"code": "DD02"
		},
		{
			"error": "Decline 9",
			"message": "DR15_ID Warning",
			"code": "DR15"
		},
		{
			"error": "Decline 10",
			"message": "DS47_No Bureau Information",
			"code": "DS47"
		},
		{
			"error": "Decline 11",
			"message": "DA97_Bureau Debt Review",
			"code": "DA97"
		},
		{
			"error": "Decline 12",
			"message": "DS43_Bureau Admin Order",
			"code": "DS43"
		},
		{
			"error": "Decline 13",
			"message": "DD38_Reduction order on file",
			"code": "DD38"
		},
		{
			"error": "Decline 14",
			"message": "DA18_Number of Dishonours L6M > 12",
			"code": "DA18"
		},
		{
			"error": "Decline 15",
			"message": "DA19_Significant Days in Excess L6M > 60",
			"code": "DA19"
		},
		{
			"error": "Decline 16",
			"message": "DD07_Bureau Not Clean",
			"code": "DD07"
		},
		{
			"error": "Decline 17",
			"message": "DR38_Bureau Installments Exceeds Income",
			"code": "DR38"
		},
		{
			"error": "Decline 18",
			"message": "DA36_Existing SBSA Loan on Record",
			"code": "DA36"
		},
		{
			"error": "Decline 19",
			"message": "DD24_MasterCard Delinquent",
			"code": "DD24"
		},
		{
			"error": "Decline 20",
			"message": "DD31_VAF Delinquent L6M",
			"code": "DD31"
		},
		{
			"error": "Decline 21",
			"message": "DD30_Home Loan Delinquent",
			"code": "DD30"
		},
		{
			"error": "Decline 22",
			"message": "DD39_WTP or ABIL Loan in Customer Profile",
			"code": "DD39"
		},
		{
			"error": "Decline 23",
			"message": "DR32_Customer is part time employed",
			"code": "DR32"
		},
		{
			"error": "Decline 24",
			"message": "DR58_Verification of Salary Required",
			"code": "DR58"
		},
		{
			"error": "Decline 25",
			"message": "DA15_Customer is under 18",
			"code": "DA15"
		},
		{
			"error": "Decline 26",
			"message": "DS16_Age > 65",
			"code": "DS16"
		},
		{
			"error": "Decline 27",
			"message": "DA08_No Identification Given",
			"code": "DA08"
		},
		{
			"error": "Decline 28",
			"message": "RA91_Advance Acnt Exposure - Refer to Credit",
			"code": "RA91"
		},
		{
			"error": "Decline 29",
			"message": "RA92_Student Loan Exposure - Refer to Credit",
			"code": "RA92"
		},
		{
			"error": "Decline 30",
			"message": "DR27_Foreign National",
			"code": "DR27"
		},
		{
			"error": "Decline 31",
			"message": "RA14_Sefl Employed MTL",
			"code": "RA14"
		},
		{
			"error": "Decline 32",
			"message": "RA96_Refer to Credit for Confirmation",
			"code": "RA96"
		},
		{
			"error": "Decline 33",
			"message": "DR33_Customer employment status is unknown",
			"code": "DR33"
		},
		{
			"error": "Decline 34",
			"message": "DA14_Non Resident",
			"code": "DA14"
		},
		{
			"error": "Decline 35",
			"message": "DP19_One Account in Customer Profile",
			"code": "DP19"
		},
		{
			"error": "Decline 36",
			"message": "DS49_Maximum Reprocess Allowed",
			"code": "DS49"
		},
		{
			"error": "Decline 37",
			"message": "DS21_Low Income Loan Recently Granted",
			"code": "DS21"
		},
		{
			"error": "Decline 38",
			"message": "DP95_LIUL Arrears",
			"code": "DP95"
		},
		{
			"error": "Decline 39",
			"message": "DE42_Existing Loans is in arrears",
			"code": "DE42"
		},
		{
			"error": "Decline 40",
			"message": "SD27_NLR Enquiry Last 1 Year",
			"code": "SD27"
		},
		{
			"error": "Decline 26",
			"message": "DS18_Occupation Status not met",
			"code": "DS18"
		},
		{
			"error": "Decline 20",
			"message": "DA38_GMI < 3000",
			"code": "DA38"
		},
		{
			"error": "Decline 21",
			"message": "DD06_Self Employed",
			"code": "DD06"
		},
		{
			"error": "Decline 15",
			"message": "DS09_Total Value of Judgments",
			"code": "DS09"
		},
		{
			"error": "Decline 13",
			"message": "DS22_SAPPL Adverse Status",
			"code": "DS22"
		},
		{
			"error": "Decline 11",
			"message": "DS23_Insufficient payment profile on Bureau",
			"code": "DS23"
		},
		{
			"error": "Refer 2",
			"message": "RR40_Requested Limit < Current Outstanding Balance",
			"code": "RR40"
		},
		{
			"error": "Refer 3",
			"message": "RA48_Age of Customer > 65",
			"code": "RA48"
		},
		{
			"error": "Decline 30",
			"message": "DD25_Unpaid Credits L6m",
			"code": "DD25"
		},
		{
			"error": "Decline 31",
			"message": "DS51_Missing Expenses",
			"code": "DS51"
		},
		{
			"error": "Decline 27",
			"message": "DD23_Age of account < 6 months",
			"code": "DD23"
		},
		{
			"error": "Decline 28",
			"message": "DD22_Recent limit increase",
			"code": "DD22"
		},
		{
			"error": "Decline 23",
			"message": "DD37_Product not Permitted",
			"code": "DD37"
		},
		{
			"error": "Decline 6",
			"message": "DA25_PL GMI < 6001 AND GMI < 8001",
			"code": "DA25"
		},
		{
			"error": "Decline 11",
			"message": "DA35_Existing RCP",
			"code": "DA35"
		},
		{
			"error": "Decline 13",
			"message": "DS40_Existing Loan",
			"code": "DS40"
		},
		{
			"error": "Decline 16",
			"message": "DR60_Existing Advanced Account",
			"code": "DR60"
		}
		];
		// additional containers
		let declined = form.querySelector('.form__declined--container');
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');
		let value = form.querySelector('.output-value');
		let name = form.querySelector('.form__success-container__firstname');
		let qualifiedAmount = form.querySelector('.form__success-container__approvedamount');

		// fields
		const description: any = form.querySelector('input[name=description]');
		const firstName: any = form.querySelector('input[name=first-name]');
		const lastName: any = form.querySelector('input[name=last-name]');
		const contact: any = form.querySelector('input[name=phone-number]');
		const contact2: any = form.querySelector('input[name=phone-number-2]');
		const gross: any = form.querySelector('input[name=gross]');
		const monthlyexpenses: any = form.querySelector('input[name=monthlyexpenses]');
		const idNum: any = form.querySelector('input[name=identification]');
		const email: any = form.querySelector('input[name=email]');
		const date: any = form.querySelector('input[name=date]');
		const time: any = form.querySelector('select[name=time]');

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitApplicationFormPC.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		let postData = '';

		if (description) {
			postData += 'description=' + description.value;
		}
		if (firstName) {
			postData += '&firstName=' + firstName.value;
		}
		if (lastName) {
			postData += '&lastName=' + lastName.value;
		}
		if (contact) {
			postData += '&contact=' + contact.value;
		}
		if (contact2) {
			postData += '&contact2=' + contact2.value;
		}
		if (gross) {
			postData += '&gross=' + gross.value;
		}
		if (monthlyexpenses) {
			postData += '&monthlyexpenses=' + monthlyexpenses.value;
		}
		if (idNum) {
			postData += '&idNum=' + idNum.value;
		}
		if (email) {
			postData += '&email=' + email.value;
		}
		if (date) {
			if (time) {
				if (time.value !== "Anytime") {
					postData += '&timeToCall=' + date.value + ' ' + time.value;
				} else {
					postData += '&timeToCall=anytime';
				}
			} else {
				postData += '&timeToCall=anytime';
			}
		}
		postData += '&source=' + this.isMobile();

		// service
		axios.post(url, postData, config).then(function (response: any) {

			let data = response.data;

			// service ok
			loader.classList.remove('active');

			if (!data.error && (data.amount || data.code)) {
				if (data.amount) {
					analyticsService.dtmFormComplete('complete', data.leadID);
					thankyou.classList.add('active');
					declined.classList.remove('active');
					error.classList.remove('active');
					success.classList.add('active');
					name.innerHTML = firstName.value;
					value.innerHTML = 'R' + data.amount;
					qualifiedAmount.innerHTML = data.amount;
				} else {
					analyticsService.dtmFormComplete('complete', data.code);
					let _tmp = errors.find((item) => {
						return item.code = data.code
					});
					if (_tmp) {
						analyticsService.dtmRecordSiteError(_tmp.message);
					} else {
						analyticsService.dtmRecordSiteError('Access Quote Declined');
					}
					thankyou.classList.add('active');
					success.classList.remove('active');
					error.classList.remove('active');
					declined.classList.add('active');
				}
			} else {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				thankyou.classList.add('active');
				success.classList.remove('active');
				declined.classList.remove('active');
				error.classList.add('active');
			}

		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');

		});

	}

	SubmitApplicationFormMail(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// fields
		const fields: any = $(form).serialize();

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitGenericForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, fields, config).then(function (response) {
			// service ok
			loader.classList.remove('active');
			analyticsService.dtmFormComplete('complete', '');
			loader.classList.remove('active');
			thankyou.classList.add('active');

		}).catch(function (response) {
			// service failed
			analyticsService.dtmFormComplete('complete', '');
			loader.classList.remove('active');
			thankyou.classList.add('active');

		});

	}

	isMobile() {
		var isMobile = (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/).test(navigator.userAgent.toLowerCase());
		if (isMobile) {
			return "MOB";
		} else {
			return "WEB";
		}
	}

}



// WEBPACK FOOTER //
// ./services/forms.service.ts